<template>
  <v-card>
    <v-toolbar color="white" light flat>
      <v-toolbar-title>Your Terminals</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>

      <template v-slot:extension>
        <v-tabs v-model="tab" icons-and-text background-color="white">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab>
            Telegram
            <v-icon>mdi-telegram</v-icon>
          </v-tab>
          <v-tab>
            Email
            <v-icon>mdi-email</v-icon>
          </v-tab>
          <v-tab>
            Webhook
            <v-icon>mdi-webhook</v-icon>
          </v-tab>
          <v-tab>
            Alert
            <v-icon>mdi-bell-alert-outline</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <telegram :accounts="accounts" :terminals="terminals" />
      </v-tab-item>
      <v-tab-item>
        <tokenEmail :accounts="accounts" :terminals="terminals" />
      </v-tab-item>
      <v-tab-item>
        <webHook :accounts="accounts" :terminals="terminals" />
      </v-tab-item>
      <v-tab-item>
        <report :accounts="accounts" :terminals="terminals" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import tokenEmail from "@/components/terminals/Email.vue";
import webHook from "@/components/terminals/WebHook.vue";
import telegram from "@/components/terminals/Telegram.vue";
import report from "@/components/terminals/Report.vue";

import { mapGetters } from "vuex";
import { ACCOUNT, TERMINAL } from "@/store/actions.type";

export default {
  name: "Terminals",
  components: {
    tokenEmail,
    webHook,
    telegram,
    report
  },
  data() {
    return {
      tab: null
    };
  },
  computed: {
    ...mapGetters(["accounts", "terminals", "currentUser", "errors"])
  },

  watch: {
    currentUser(v) {
      if (v.id && !this.accounts) {
        this.$store.dispatch(ACCOUNT.FETCH, v.id);
      }
      if (v.id && !this.terminals) {
        this.$store.dispatch(TERMINAL.FETCH, v.id);
      }
    }
  },

  methods: {}
};
</script>

<style></style>
